import { useCallback } from 'react'
// import { makeStyles } from '@material-ui/core/styles'
import { useSelector, useDispatch } from 'react-redux'

import RotateRightIcon from '@material-ui/icons/RotateRight'
import BottomBarButton from '../BottomBar/BottomBarButton'

import { rotationSelector, setRotation } from '../../modules/reducerPDFViewer'

// const useStyles = makeStyles((theme) => ({
//   root: {}
// }))

const PDFRotateRightButton = (props) => {
  // const classes = useStyles()
  const rotation = useSelector(rotationSelector)
  const dispatch = useDispatch()

  const handleClick = useCallback(() => {
    dispatch(setRotation(rotation + 90))
  }, [dispatch, rotation])

  return (
    <BottomBarButton
      {...props}
      tooltip="Rotar sentido horario"
      tooltipEnabled={true}
      onClick={handleClick}
      disabled={false}
    >
      <RotateRightIcon fontSize="inherit" />
    </BottomBarButton>
  )
}
export default PDFRotateRightButton
